import ListIcon from '@material-ui/icons/ViewList';

import DisciplineReport from './DisciplineReport';

export default {
    list: DisciplineReport,
    icon: ListIcon,
};
